import {
  switch_styles_default
} from "./chunk.6LZA5TIL.js";
import {
  SlSwitch
} from "./chunk.ODLLSXVI.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/switch/switch.ts
var FadvSwitch = class extends SlSwitch {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "checked", "unchecked");
    this._hasFocus = false;
    this.size = "large";
  }
  handleBlur() {
    this._hasFocus = false;
    super.handleBlur();
  }
  handleFocus() {
    this._hasFocus = true;
    super.handleFocus();
  }
  render() {
    return $`<label part="base" class=${o({
      switch: true,
      "switch--checked": this.checked,
      "switch--disabled": this.disabled,
      "switch--focused": this._hasFocus,
      "switch--small": this.size === "small",
      "switch--has-toggle-label": this.checkedLabel && this.uncheckedLabel || this.hasSlot.test("checked") && this.hasSlot.test("unchecked")
    })} ><input class="switch__input" type="checkbox" name=${l(this.name)} value=${l(this.value)} .checked=${l2(this.checked)} .disabled=${this.disabled} .required=${this.required} role="switch" aria-checked=${this.checked ? "true" : "false"} @click=${this.handleClick} @blur=${this.handleBlur} @focus=${this.handleFocus} @keydown=${this.handleKeyDown} /><span part="control" class="switch__control"><span part="toggle-label" class="switch__toggle-label"><span class="switch__toggle-label-on"><slot name="checked">${this.checkedLabel}</slot></span><span class="switch__toggle-label-off"><slot name="unchecked">${this.uncheckedLabel}</slot></span></span><span part="thumb" class="switch__thumb"></span></span><span part="label" class="switch__label"><slot></slot></span></label>`;
  }
};
FadvSwitch.styles = switch_styles_default;
__decorateClass([
  t()
], FadvSwitch.prototype, "_hasFocus", 2);
__decorateClass([
  e({ attribute: "checked-label" })
], FadvSwitch.prototype, "checkedLabel", 2);
__decorateClass([
  e({ attribute: "unchecked-label" })
], FadvSwitch.prototype, "uncheckedLabel", 2);
__decorateClass([
  e({ reflect: true })
], FadvSwitch.prototype, "size", 2);
FadvSwitch = __decorateClass([
  n("fadv-switch")
], FadvSwitch);

export {
  FadvSwitch
};
